<ng-container [ngSwitch]="data">
  <div *ngSwitchCase="'1'" i18n="@@common.postback_with_click">Postback with Click ID</div>
  <div *ngSwitchCase="'2'" i18n="@@common.iframe_pixel">iFrame pixel</div>
  <span *ngSwitchDefault class="c-field-value__text -light-gray" i18n="@@common.empty">Empty</span>
</ng-container>
